import FieldControl from 'global/form/FieldControl';
import * as adapters from 'global/form/validationAdapters';

class AdditionalCheckFieldControl extends FieldControl {
	constructor(field, rules, fields) {
		super(field, rules);
		if (!fields) {
			throw TypeError('Invalid arguments in constructor');
		}
		this.relevantFields = this.getRelevantFields(
			fields,
			'additionalCheckFormField',
		);
		this.attachEventsToRelevantFields();
	}

	getRelevantFields(fields, key) {
		const { rule: requiredFields } = this.rules[key];
		return fields.filter(field => requiredFields.includes(field.name));
	}

	attachEventsToRelevantFields() {
		const eventType =
			this.field.getAttribute('data-validation-event') || 'blur';
		this.relevantFields.forEach(field => {
			if (field !== this.field) {
				// event is already attached for this.field
				field.addEventListener(eventType, () => this.validateField());
			}
		});
	}

	validateRule(key) {
		if (key === 'additionalCheckFormField') {
			return this.validateAdditionalCheckFormField();
		}

		return super.validateRule(key);
	}

	validateAdditionalCheckFormField() {
		const nonEmptyFields = this.relevantFields.filter(field =>
			adapters.required(field.value),
		);
		return nonEmptyFields.length >= 1;
	}

	// TODO: The entire form validation needs rework because it's no longer fit for purpose.
	isOptional() {
		return false;
	}
}

export default AdditionalCheckFieldControl;
